import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c632874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-eidtor" }
const _hoisted_2 = { class: "box-components" }
const _hoisted_3 = { class: "component-toolbar" }
const _hoisted_4 = { class: "btn-group" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "box-add" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "toolbar-holder" }, null, -1))
const _hoisted_16 = { class: "box-toolbar" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "box-toolbar-content" }

import { reactive, ref, onMounted, onBeforeUnmount, provide, nextTick, useAttrs } from 'vue';
  import _ from 'lodash';
  import { alert } from '@/utils';
  import { AdminSdk } from './admin-sdk';
  import { ICustomList } from '@/types/custom-list';
  import { ISnippet } from '@/types/snippet';
  import { useI18n } from 'vue-i18n';
  import { ColorVariants } from '@/constants';
  import allComponents, { IComponent } from './components';

  interface IProps {
    initComponents: IComponent[];
    sourceId?: number | string; // id = admin自定义页面资源id
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    initComponents: null,
    sourceId: null
  },
  setup(__props: any) {

const props = __props as {
    initComponents: IComponent[];
    sourceId?: number | string; // id = admin自定义页面资源id
  }

  const { t } = useI18n();
  
  const attrs = useAttrs();
  const components = reactive<IComponent[]>(JSON.parse(JSON.stringify(props.initComponents || []))); // 页面组件

  // 页面被嵌入iframe时默认表示是编辑模式
  const adminSdk = new AdminSdk();
  const snippets = ref<ISnippet[]>([]);
  const banners = ref<ICustomList[]>([]);
  const programs = ref<ICustomList[]>([]);
  const products = ref<ICustomList[]>([]);
  const stories = ref<ICustomList[]>([]);

  provide('editorMode', true);
  provide('adminSdk', adminSdk);
  provide('snippets', snippets);
  provide('banners', banners);
  provide('programs', programs);
  provide('shops', products);
  provide('stories', stories);

  const fetchListData = async () => {
    // 请求其他列表资源
    const [{ data: snippetsData }, { data: customList }] = await Promise.all([
      adminSdk.request({ data: { method: 'get', url: 'custom_snippets', params: { page: 0 } } }),
      adminSdk.request({ data: { method: 'get', url: 'custom_lists', params: { page: 0 } } })
    ]);
    snippets.value = snippetsData;
    const customListGroupByType = _.groupBy(customList as ICustomList[], 'type');
    programs.value = customListGroupByType.CustomProgramList || [];
    banners.value = customListGroupByType.CustomBannerList || [];
    products.value = customListGroupByType.CustomProductList || [];
    stories.value = customListGroupByType.CustomStoryList || [];
  };

  onMounted(async () => {
    fetchListData();
  });

  onBeforeUnmount(() => {
    adminSdk.destroy();
  });

  const handleRefresh = async (index: number) => {
    const props = JSON.stringify(components[index].props);
    components[index].props = {};
    await nextTick();
    components[index].props = JSON.parse(props);
  };
  const handleEdit = (index: number) => {
    components[index].showController = true;
    // 刷新一下最新列表数据
    fetchListData();
  };
  const handleAdd = async (name: string | number) => {
    const { props, hasContainer, hasController } = allComponents[name];
    components.push({
      name: String(name),
      hasContainer,
      showController: true,
      props: _.cloneDeep(props),
      hasController
    });
    // 刷新一下最新列表数据
    fetchListData();
  };
  const handleMove = (currentIndex: number, toIndex: number) => {
    components.splice(toIndex, 0, components.splice(currentIndex, 1)[0]);
  };
  const handleDelete = (index: number) => {
    components.splice(index, 1);
  };
  const handleChange = (index: number, props: { [key: string]: any }) => {
    Object.assign(components[index].props, props);
  };
  const handleToggleController = (index: number, showController: boolean) => {
    components[index].showController = showController;
  };
  const handleToogleHasContainer = (index: number) => {
    components[index].hasContainer = !components[index].hasContainer;
  };
  const handleSave = async ({ showSuccessMsg = true } = {}) => {
    const body = {
      id: props.sourceId,
      configs: JSON.stringify(
        {
          components: components
        }
      )
    };
    await adminSdk.request({
      data: {
        url: `custom_pages/${props.sourceId}`,
        method: 'put',
        data: body
      }
    });
    if (showSuccessMsg) {
      alert({ title: t('Success'), content: t('Operation success'), });
    }
  };

  const handleGoBack = () => {
    adminSdk.goBack();
  };

  const handlePublish = async () => {
    await handleSave({ showSuccessMsg: false });
    await adminSdk.request({
      data: {
        url: `custom_pages/${props.sourceId}/publish`,
        method: 'post',
      }
    });
    alert({ title: t('Success'), content: t('Operation success'), });
  };

return (_ctx: any,_cache: any) => {
  const _component_AppCustomPage = _resolveComponent("AppCustomPage")!
  const _component_AppLoadingButton = _resolveComponent("AppLoadingButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AppCustomPage, _mergeProps({
        components: _unref(components),
        "on-toggle-show-controller": handleToggleController,
        "on-change": handleChange
      }, _unref(attrs)), {
        default: _withCtx(({ index, component }) => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-sm",
                onClick: ($event: any) => (handleRefresh(index))
              }, _toDisplayString(_unref(t)('refresh')), 9, _hoisted_5),
              _createElementVNode("button", {
                class: "btn btn-danger btn-sm",
                onClick: ($event: any) => (handleDelete(index))
              }, _toDisplayString(_unref(t)('delete')), 9, _hoisted_6),
              _createElementVNode("button", {
                class: "btn btn-warning btn-sm",
                onClick: ($event: any) => (handleToogleHasContainer(index))
              }, _toDisplayString(_unref(t)('toogleHasContainer')), 9, _hoisted_7),
              (index !== 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-success",
                    onClick: ($event: any) => (handleMove(index, index - 1))
                  }, _toDisplayString(_unref(t)('moveUp')), 9, _hoisted_8))
                : _createCommentVNode("", true),
              (index + 1 < _unref(components).length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-success",
                    onClick: ($event: any) => (handleMove(index, index + 1))
                  }, _toDisplayString(_unref(t)('moveDown')), 9, _hoisted_9))
                : _createCommentVNode("", true),
              (component.hasController !== false)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "btn btn-primary btn-sm",
                    onClick: ($event: any) => (handleEdit(index))
                  }, _toDisplayString(_unref(t)('edit')), 9, _hoisted_10))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 16, ["components"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allComponents), (item, name) => {
            return (_openBlock(), _createElementBlock("div", {
              key: name,
              class: "col-6 col-md-2"
            }, [
              _createElementVNode("div", {
                class: "btn-component",
                onClick: ($event: any) => (handleAdd(name))
              }, _toDisplayString(name), 9, _hoisted_14)
            ]))
          }), 128))
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#app-footer" }, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createVNode(_component_AppLoadingButton, {
              variant: _unref(ColorVariants).outlinePrimary,
              onClick: handleGoBack
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('goBack')), 1)
              ]),
              _: 1
            }, 8, ["variant"]),
            _createVNode(_component_AppLoadingButton, {
              variant: _unref(ColorVariants).primary,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSave()))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Save')), 1)
              ]),
              _: 1
            }, 8, ["variant"]),
            _createVNode(_component_AppLoadingButton, {
              variant: _unref(ColorVariants).danger,
              onClick: handlePublish
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('publish')), 1)
              ]),
              _: 1
            }, 8, ["variant"])
          ])
        ])
      ])
    ]))
  ]))
}
}

})